import ChatList from "./chat-list";
import { PlusIcon } from "lucide-react";
import { Text } from "../ui/text";
import { useNavigate } from "react-router-dom";
import { AI_HOME_PATHNAME } from "@/constants/pathname";
import useSideBarStore from "@/stores/side-bar";
import { useState, useEffect } from "react";

const AiSideBar = () => {
  const navigate = useNavigate();
  const isOpen = useSideBarStore((state) => state.isOpen);
  const [isNarrow, setIsNarrow] = useState(window.innerWidth < 1080);

  useEffect(() => {
    const handleResize = () => {
      setIsNarrow(window.innerWidth < 1080);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showCollapsed = isOpen || isNarrow;

  const handleNewChat = () => {
    navigate(AI_HOME_PATHNAME);
  };

  return (
    <div>
      {/* 축소된 메뉴 */}
      {showCollapsed && (
        <div className="w-[72px] shrink-0 min-h-common-height bg-gray-50 border-r border-grey-90 py-[32px] px-4 flex flex-col justify-between">
          <button
            onClick={handleNewChat}
            className="w-10 h-10 flex justify-center items-center"
          >
            <PlusIcon />
          </button>
        </div>
      )}
      {/* 펼쳐진 메뉴 */}
      {!showCollapsed && (
        <div className="w-[214px] shrink-0 min-h-common-height bg-gray-50 border-r border-grey-90 py-[32px] px-2 flex flex-col justify-between">
          <div className="flex flex-col gap-[24px]">
            <button className="flex items-center" onClick={handleNewChat}>
              <div className="w-[40px] h-[40px] flex justify-center items-center">
                <PlusIcon />
              </div>
              <Text variant={"title-md"}>New Chat</Text>
            </button>
            <ChatList />
          </div>
        </div>
      )}
    </div>
  );
};

export default AiSideBar;
